export const LOAD_ACTIVE_CUSTOMERS = 'PRODUCT_USAGE/ACTIVE_CUSTOMERS';
export const LOAD_ACTIVE_USERS = 'PRODUCT_USAGE/ACTIVE_USERS';
export const LOAD_CUSTOMERS_MONTH = 'PRODUCT_USAGE/CUSTOMERS_MONTH';
export const LOAD_FREEMIUM_MONTH = 'PRODUCT_USAGE/FREEMIUM_MONTH';
